import React, { Component } from 'react';
import Word from '../Misc/Word.js';
import NodePP from './NodePP.js';


class LinePP extends Component {

  renderPressurePoint() {
   var line = { before: [], pressurePoint: [], after: [] },
   range = this.props.data.range;

   const {currentPP} = this.props.statePP;

   //start and end for pressure point slice
   let start = range[0] -1,
   end = range.length === 2 ? range[1] -1 : range[0] -1;

   this.props.words.forEach((wordNode, key) => {
     let colored = false, position;
     //Three arrays: before pp, in pp, and after pp
     if(key < start){
       position = 'before';
     } else if(key >= start && key <= end){
       colored = true;
       position = 'pressurePoint';
     } else if(key > end){
       position = 'after';
     }
     let ele = <Word key={'word_'+ key} colored={colored}>{wordNode}</Word>;
     line[position].push(ele)
   });

   const selected = currentPP === this.props.data.key ? true : false;

   return [
     line.before,
     <NodePP
       key= {"PP_" + this.props.data.key}
       data = {this.props.data}
       selected = {selected}
       currentPP = {currentPP}
       togglePP = {this.props.togglePP}>
       {line.pressurePoint}
     </NodePP>,
     line.after
   ];
 }

  render(){
    const payload = this.renderPressurePoint();
    return (
      <li className = "line">
        {payload}
      </li>
    )
  }
}

export default LinePP;



// WEBPACK FOOTER //
// ./src/components/PressurePoint/LinePP.js